import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e37d020c"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e37d020c')) {
      api.createRecord('e37d020c', component.options)
    } else {
      api.reload('e37d020c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=e37d020c", function () {
      api.rerender('e37d020c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-setting/goods/barcode/config/index.vue"
export default component.exports